import * as yup from "yup";
import { MSG } from "../constants/MSG";
import { isPossiblePhoneNumber } from "react-phone-number-input";

export const generalSettingsSchema = yup.object().shape({
	platform_fee_percentage: yup
		.string()
		.trim()
		.matches(
			new RegExp(/^(?:100|\d{1,2})(?:\.\d{1,2})?$/),
			MSG.REQUIRED_VALID_OPA_COMISSION
		)
		.required(MSG.REQUIRED_OPA_COMMISSION)
		.test(
			"Is positive?",
			MSG.REQUIRED_OPA_COMMISSION_GREATER_THAN_1,
			(value) => value > 1
		)
		.test(
			"Is positive?",
			MSG.REQUIRED_OPA_COMMISSION_LESS_THAN_100,
			(value) => value < 100
		),
});

export const contactSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.email(MSG.REQUIRED_PROPER_EMAIL)
		.required(MSG.REQUIRED_EMAIL),
	mobile: yup
		.string()
		.trim()
		.required(MSG.PROVIDE_MOBILE_NUMBER)
		.test("Is Valid Phone Number", MSG.REQUIRED_PROPER_MOBILE_NUMBER, (value) =>
			isPossiblePhoneNumber(value)
		)
		.nullable(),
	// .matches(
	// 	new RegExp(/^\(?([0-9]{0,3})\)?[-. ]?([0-9]{0,3})[-. ]?([0-9]{10,10})$/),
	// 	MSG.REQUIRED_PROPER_MOBILE_NUMBER
	// ),
});
